import { createRef, RefObject, useEffect, useRef, useState } from "react";

import { Icon } from "@newsela/angelou";

import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { FilterSection } from "@/search/NewSearchPageMVP/shared/FilterSection";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { InstructionalFeatureCheckbox } from "./InstructionalFeatureCheckbox";
import { fieldsetCss, legendCss } from "./InstructionalFeature.styles";
import {
  INSTRUCTIONAL_FEATURE_OPTIONS,
  InstructionFeatureValuesEnum,
} from "./InstructionalFeature.constants";

export const InstructionalFeature = () => {
  const { data: user } = useUser();
  const { activeELALicense, canSeeFormative } = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });

  const {
    handlers: { getSearchParamValues },
  } = useSearchPageContext();

  const checkboxRefs = useRef(
    INSTRUCTIONAL_FEATURE_OPTIONS.map(() => createRef<HTMLInputElement>()),
  );

  const [isDomReady, setIsDomReady] = useState(false);

  useEffect(() => {
    setIsDomReady(true);
  }, []);

  const canSeePowerWords = activeELALicense;
  if (!canSeeFormative && !canSeePowerWords) return null;

  const hasNoInstructionalFeaturesValues =
    getSearchParamValues(AgathaSchemaParamsEnum.instructional_features)
      .length === 0;

  return (
    <FilterSection
      title="Instructional feature"
      defaultCollapsed={hasNoInstructionalFeaturesValues}
    >
      <fieldset css={fieldsetCss}>
        <legend css={legendCss}>Filter content by instructional feature</legend>
        {INSTRUCTIONAL_FEATURE_OPTIONS.map((option, index) => {
          const currentRef = checkboxRefs?.current?.[
            index
          ] as RefObject<HTMLInputElement>;
          const targetElement = currentRef?.current?.nextSibling
            ?.nextSibling as Element;

          if (
            option.value === InstructionFeatureValuesEnum.power_words &&
            !canSeePowerWords
          )
            return null;

          if (
            option.value === InstructionFeatureValuesEnum.has_formative &&
            !canSeeFormative
          )
            return null;

          return (
            <InstructionalFeatureCheckbox
              key={index}
              paramName={AgathaSchemaParamsEnum.instructional_features}
              option={option}
              currentRef={currentRef}
              isDomReady={isDomReady}
              targetElement={targetElement}
              IconComponent={<Icon SvgComponent={option.SvgComponent} />}
            />
          );
        })}
      </fieldset>
    </FilterSection>
  );
};
